import { drawSignatures } from '../signature'
import { appendImages } from '../image'
import jsPDF from 'jspdf'
import { mainDailyPageImage } from '../draw-page/mainDailyPageImg'
import { otherPageImg } from '../draw-page/otherPageImg'
import { emptyA4Canvas } from '../canvasDraw'
import { nLinesInWorkDescription } from '../draw-page/texts'
import { maxNLinesOnMainPageWorkDescription } from '../draw-page/lower/workDescription'

/**
 * Creates jsPdf doc with blue and red pages and appended images
 * @param {import('../constructionLog').ConstructionLog} constructionLog 
 * @param {AttachedResources} attachedResources 
 */
export const getDocWithPagesAndImages = (constructionLog, attachedResources) => {
  let doc = newBlankPDF()
  constructionLog.log_pages.forEach((page, pageI) => {
    /** @param {'blue' | 'red'} color */
    const appendDailyLogPage = color => {
      const [mainImg, otherImg, hasOverflow] = getFrameImgs(constructionLog, pageI, color)
      appendPageWithImage(doc, mainImg)
      drawSignatures(doc, attachedResources.signatures[pageI])
      const addSecond = constructionLog.always_add_second_page || hasOverflow
      if (addSecond) {
        appendPageWithImage(doc, otherImg)
      }
      appendImages(doc, attachedResources.imgsWithDimensions[pageI])
    }
    appendDailyLogPage('blue')
    appendDailyLogPage('red')
  })
  return doc
}

/**
 * @param {jsPDF} doc 
 * @param {string} img 
 */
const appendPageWithImage = (doc, img) => {
  doc.addPage()
  doc.addImage(img, 'JPEG', 0, 0, 297, 210, '', 'FAST')
}

const newBlankPDF = () => {
  let options = {
    orientation: 'l',
    compress: true,
    putOnlyUsedFonts: true
  }
  let doc = new jsPDF(options)
  // Delete first page to start with blank document:
  doc.deletePage(1)
  return doc
}

/**
 * @param {import('../constructionLog').ConstructionLog} constructionLog
 * @param {number} pageI
 * @param {string} color
 */
const getFrameImgs = (constructionLog, pageI, color) => {
  let page = constructionLog.log_pages[pageI]
  const main = mainDailyPageImage(constructionLog, pageI, color)
  // Calculate overflow: render work description line count on a temp canvas
  const tempContext = emptyA4Canvas().getContext('2d')
  const nLines = nLinesInWorkDescription(tempContext, page.work_description)
  const hasOverflow = nLines > maxNLinesOnMainPageWorkDescription
  const other = otherPageImg(page, color)
  return [main, other, hasOverflow]
}